import {useEffect, useState} from "react";
import {BooksitoutServer} from "../../../../config/BooksitoutServer";
import SearchSettingsResponse from "../../../appUsers/settings/response/BookSearchSettingsResponse";
import useLoginStore from "../../../login/useLoginStore";

let cachedSettings: SearchSettingsResponse | null = null
let fetchPromise: Promise<SearchSettingsResponse> | null = null
let listeners: Set<(s: SearchSettingsResponse | null) => void> = new Set()

const notifyListeners = (s: SearchSettingsResponse | null) => {
    cachedSettings = s
    listeners.forEach(l => l(s))
}

const useBookSearchSettings = () => {
    const [settings, setSettings] = useState<SearchSettingsResponse | null>(cachedSettings)

    const isLoggedIn = useLoginStore(state => state.isLoggedIn())

    useEffect(() => {
        listeners.add(setSettings)
        return () => { listeners.delete(setSettings) }
    }, [])

    useEffect(() => {
        if (isLoggedIn && !cachedSettings && !fetchPromise) {
            fetchSettings()
        }
    }, [isLoggedIn])

    const fetchSettings = () => {
        if (!isLoggedIn) return
        if (fetchPromise) return

        fetchPromise = BooksitoutServer
            .get(`/v1/book/search/settings`)
            .then((res) => {
                notifyListeners(res.data)
                fetchPromise = null
                return res.data
            })
            .catch(() => {
                fetchPromise = null
                return null
            }) as Promise<SearchSettingsResponse>
    }

    const refresh = () => {
        fetchPromise = null
        if (isLoggedIn) {
            fetchPromise = BooksitoutServer
                .get(`/v1/book/search/settings`)
                .then((res) => {
                    notifyListeners(res.data)
                    fetchPromise = null
                    return res.data
                })
                .catch(() => {
                    fetchPromise = null
                    return null
                }) as Promise<SearchSettingsResponse>
        }
    }

    return [settings, refresh] as const
}

export default useBookSearchSettings
